import { useSteps } from "chakra-ui-steps";
import { createCtx } from "./lib";

type Stepper = {
  nextStep: () => void;
  prevStep: () => void;
  reset: () => void;
  setStep: (step: number) => void;
  activeStep: number;
};

type BookingContextType = {
  stepr: Stepper;
};

const [useBookingContext, ContextProvider] = createCtx<BookingContextType>();

const BookingProvider: React.FC = ({ children }) => {
  const stepr = useSteps({ initialStep: 0 });

  const value: BookingContextType = {
    stepr,
  };

  return <ContextProvider value={value}>{children}</ContextProvider>;
};

export { BookingProvider, useBookingContext };
